


































import Vue from 'vue';
import Component from 'vue-class-component';
import { DocsSource } from '../../data/DocsSource';

const DocsNavbarVue = Vue.extend({ props: {
	source: DocsSource,
	sources: Object
} });

@Component
export default class DocsNavbar extends DocsNavbarVue {

	sourceChoice = this.source.id;
	tagChoice = this.source.defaultVersion;

	tags: string[] | null = null;

	async beforeMount(): Promise<void> {
		await this.loadTags();
	}

	async loadTags(): Promise<void> {
		this.tags = this.source.tags;
		if (!this.tags) {
			const startSource = this.source;
			const tags = await this.source.fetchTags();
			if (this.source.id === startSource.id) this.tags = tags as string[];
		}
	}

}
